import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Reveal } from "../components/Reveal";

const GROUPS = [
  {
    title: "Ordering & shipping",
    items: [
      { q: "Where do you ship?", a: "We currently ship across Canada. Free standard shipping on all Canadian orders — no minimum purchase required." },
      { q: "How fast will my order arrive?", a: "Orders are packed and shipped within 1–2 business days. Delivery typically takes 3–7 business days depending on your location." },
      { q: "Can I track my order?", a: "Yes — you'll receive a tracking link by email as soon as your order ships." },
    ],
  },
  {
    title: "Products & sizing",
    items: [
      { q: "How do I pick the right size?", a: "Each product page has a sizing guide. Measure your dog's chest (harness) or neck (collar) at the widest point. Between sizes? Size up." },
      { q: "What is the collar made of?", a: "Padded PU / faux-leather with rust-resistant hardware. It softens with wear and is engraved directly — no tags to lose." },
      { q: "Are the leashes and harnesses reflective?", a: "Yes. Reflective stitching and tape are built in for visibility on early mornings and evening walks." },
    ],
  },
  {
    title: "Returns & personalization",
    items: [
      { q: "What's your return policy?", a: "Unused items can be returned within 30 days for a refund. Personalized collars are made to order and non-returnable unless faulty." },
      { q: "Can I change my personalization after ordering?", a: "Reach out within a few hours of ordering and we'll do our best to update it before it goes into production." },
    ],
  },
];

export default function FAQ() {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <div className="pt-28 md:pt-36" data-testid="faq-page">
      <header className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <p className="font-manrope text-xs uppercase tracking-[0.15em] font-bold text-rust">Good to know</p>
          <h1 className="mt-4 max-w-3xl font-fraunces text-5xl font-light leading-[1.02] md:text-7xl">
            Questions, before the walk.
          </h1>
        </Reveal>
      </header>

      <section className="mx-auto max-w-[1400px] px-5 py-16 md:px-10 md:py-24">
        <div className="flex flex-col gap-14">
          {GROUPS.map((g, gi) => (
            <div key={gi} className="grid gap-6 md:grid-cols-12">
              <h2 className="font-fraunces text-2xl md:col-span-4 md:text-3xl">{g.title}</h2>
              <div className="md:col-span-7 md:col-start-6">
                <Accordion type="single" collapsible data-testid={`faq-group-${gi}`}>
                  {g.items.map((it, i) => (
                    <AccordionItem key={i} value={`${gi}-${i}`}>
                      <AccordionTrigger className="text-left font-manrope text-lg">{it.q}</AccordionTrigger>
                      <AccordionContent className="font-manrope text-ink">{it.a}</AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 border-t border-charcoal/10 pt-10 font-manrope text-lg">
          Still have a question?{" "}
          <Link to="/contact" className="underline underline-offset-4 hover:text-rust" data-testid="faq-contact-link">
            Get in touch
          </Link>
          .
        </div>
      </section>
    </div>
  );
}
